
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/em-alta",
      function () {
        return require("private-next-pages/promocoes/em-alta.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/em-alta"])
      });
    }
  